import { render, staticRenderFns } from "./popup-product-operation.vue?vue&type=template&id=45b7e6a4&scoped=true&"
import script from "./popup-product-operation.vue?vue&type=script&lang=js&"
export * from "./popup-product-operation.vue?vue&type=script&lang=js&"
import style0 from "./popup-product-operation.vue?vue&type=style&index=0&id=45b7e6a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b7e6a4",
  null
  
)

export default component.exports